interface State {
  hoverToDeleteItem: number | null;
}

export const useContextMenuHoverDelete = defineStore(
  "context-menu-hover-delete",
  {
    state: (): State => ({
      hoverToDeleteItem: null,
    }),
  }
);
